<template>
  <div class="md-layout-item md-size-50 md-small-size-90">
    <div v-if="!order.success">
      <h3 class="title">
        Mittagstisch in ihrem Dorfladen
      </h3>
      <h5>
        Ihr Dorfladen bietet ihnen täglich frische Gerichte. Diese können Sie
        hier vorbestellen. Wählen Sie dazu einfach einen der unten stehenden
        Zeiträume aus.
      </h5>
      <div class="md-layout-item md-size-100">
        <md-table v-model="menuPlanItems" class="table-shopping">
          <md-table-row
            v-if="item.active"
            slot="md-table-row"
            slot-scope="{ item }"
          >
            <md-table-cell>
              {{ item.title }}
              <md-button
                style="margin-top: 25px;"
                class="md-round md-block md-primary md-large"
                @click="openOrderForm(item)"
              >
                Bestellen
              </md-button>
            </md-table-cell>
            <md-table-cell>
              <div style="margin-bottom: 55px; padding-top: 0px;">
                {{ item.description }}
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
    <br />
    <div class="md-layout-item md-size-60 md-xsmall-size-100">
      <div class="modal modal-bg" :class="{ show: showSection }">
        <modal
          v-if="showSection"
          modal-with-card
          type="modal-signup"
          card-classes="md-card-signup"
          @close="showSection = false"
        >
          <template slot="header">
            <md-button
              class="md-simple md-close md-just-icon md-round modal-default-button"
              @click="showSection = false"
            >
              <md-icon>clear</md-icon>
            </md-button>
            <h3 class="title text-center">
              Gerichte auswählen und reservieren lassen
            </h3>
          </template>

          <template slot="body">
            <div class="md-layout">
              <div
                slot="content-left"
                class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 ml-auto"
              >
                <div
                  v-bind:key="menuPlanItem.menuDate"
                  v-for="menuPlanItem in selectedMenuPlan.menuPlanItems"
                  style="margin-bottom: 40px"
                >
                  <h5 style="padding-bottom: 0px;">
                    Gerichte am
                    {{ menuPlanItem.formattedMenuDate.slice(0, -5) }}
                  </h5>
                  <md-table
                    v-model="menuPlanItem.menuItems"
                    class="table-striped"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell class="md-table-cell-small">
                        <md-button
                          class="md-just-icon md-round md-simple md-primary"
                          @click="
                            addDish(
                              item,
                              menuPlanItem.formattedMenuDate.slice(0, -5)
                            )
                          "
                        >
                          <md-icon>add</md-icon>
                        </md-button>
                      </md-table-cell>
                      <md-table-cell
                        class="md-table-cell-small"
                        md-label="Gericht"
                      >
                        {{ item.title }}
                      </md-table-cell>
                      <md-table-cell class="md-table-cell-small">
                        {{ item.unit }}</md-table-cell
                      >
                      <md-table-cell
                        class="md-table-cell-small"
                        md-label="Preis"
                      >
                        {{ item.price }}€
                      </md-table-cell>
                      <md-table-cell
                        class="md-table-cell-small"
                        md-label="Infos"
                      >
                        {{ item.description }}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
              <div
                slot="content-right"
                class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 mr-auto"
              >
                <br />
                <h4 class="text-center">Meine Vorbestellung:</h4>
                <md-table v-model="order.orderItems" class="table-striped">
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item, index }"
                  >
                    <md-table-cell class="md-table-cell-small">
                      1x
                    </md-table-cell>
                    <md-table-cell
                      class="md-table-cell-small"
                      md-label="Gericht"
                    >
                      {{ item.title }}
                    </md-table-cell>
                    <md-table-cell class="md-table-cell-small">
                      {{ item.unit }}
                    </md-table-cell>
                    <md-table-cell class="md-table-cell-small" md-label="Preis">
                      {{ item.price }}€
                    </md-table-cell>
                    <md-table-cell class="md-table-cell-small" md-label="Datum">
                      {{ item.formattedOrderDate }}
                    </md-table-cell>
                    <md-table-cell class="md-table-cell-small">
                      <md-button
                        class="md-just-icon md-round md-simple"
                        @click="removeDish(index)"
                      >
                        <md-icon>clear</md-icon>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <div class="table table-stats" stlye="margin-top: 5px;">
                  <hr />
                  <div class="td-price">
                    <div class="td-total">
                      Gesamt
                    </div>
                    <span>
                      {{ gesNet }}
                      <small>€</small>
                    </span>
                  </div>
                </div>
                <br />
                <br />
                <form>
                  <md-field class="md-form-group">
                    <md-icon>face</md-icon>
                    <label>Vorname*</label>
                    <md-input v-model="order.prename" type="text" />
                  </md-field>
                  <md-field class="md-form-group">
                    <md-icon>face</md-icon>
                    <label>Nachname*</label>
                    <md-input v-model="order.surname" type="text" />
                  </md-field>
                  <md-field class="md-form-group">
                    <md-icon>phone</md-icon>
                    <label>Telefon</label>
                    <md-input v-model="order.phone" type="text" />
                  </md-field>
                  <md-field class="md-form-group">
                    <md-icon>email</md-icon>
                    <label>E-Mail</label>
                    <md-input v-model="order.email" type="email" />
                  </md-field>
                  <md-field class="md-form-group">
                    <label>Anmerkungen</label>
                    <md-textarea v-model="order.description" type="text" />
                  </md-field>
                  <br />
                  <h6 v-if="order.incomplete" class="error-message">
                    FEHLER - Bitte überprüfen Sie die Vollständigkeit Ihrer
                    Angaben.
                  </h6>
                  <h6 v-if="order.error" class="error-message">
                    FEHLER - Leider konnten Ihre Daten nicht verarbeitet werden,
                    bitte versuchen Sie es später erneut.
                  </h6>
                  <div class="button-container justify-content-center">
                    <md-button
                      @click="submitShare(selectedMenuPlan.id)"
                      class="md-success md-round mt-3"
                    >
                      Anfrage absenden
                    </md-button>
                  </div>
                  <br />
                  <p>* diese Felder werden benötgt</p>
                </form>
              </div>
            </div>
          </template>
        </modal>
      </div>
      <div class="modal modal-bg" :class="{ show: order.success }">
        <modal
          v-if="order.success"
          modal-with-card
          type="modal-signup"
          card-classes="md-card-signup"
          @close="order.success = false"
        >
          <template slot="header">
            <md-button
              class="md-simple md-close md-just-icon md-round modal-default-button"
              @click="order.success = false"
            >
              <md-icon>clear</md-icon>
            </md-button>
            <h3 class="title text-center">
              Vielen Dank!
            </h3>
          </template>

          <template slot="body">
            <div class="md-layout">
              <h5
                style="
    margin-left: auto;
    margin-right: auto;
"
                class="title text-center"
              >
                Ihre Bestellung wurde erfolgreich versendet!
              </h5>
              <br />
              <md-button
                style="margin-top: 25px; margin-left: 25px; margin-right: 25px;"
                class="md-round md-block md-primary"
                @click="order.success = false"
              >
                Schließen
              </md-button>
            </div>
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Modal } from "@/components";
import axios from "axios";
export default {
  components: {
    Modal,
  },
  props: ["did"],
  data() {
    return {
      showSection: false,
      successModal: false,
      menuPlanItems: [],
      selectedMenuPlan: {},
      gesNet: 0,
      order: {
        prename: "",
        surname: "",
        phone: "",
        email: "",
        incomplete: false,
        error: false,
        success: false,
        user: null,
        orderItems: [],
      },
    };
  },
  computed: {
    ...mapGetters(["backendServer"]),
  },
  mounted() {
    //query menu plan items
    this.$store.dispatch("queryMenuPlanItems", this.did).then((r) => {
      this.menuPlanItems = r;
    });
  },
  methods: {
    openOrderForm(item) {
      this.showSection = true;
      this.selectedMenuPlan = item;
    },
    addDish(item, formattedOrderDate) {
      //add dish to order.orderItems
      item.formattedOrderDate = formattedOrderDate;
      this.order.orderItems.push(item);
      //format price
      this.format(this.order.orderItems);
    },
    removeDish(index) {
      //remove item with index
      this.order.orderItems.splice(index, 1);
      //format price
      this.format(this.order.orderItems);
    },
    format(val) {
      if (val.length === 0) {
        this.gesNet = 0;
        return 0;
      }
      let nets = val.map((inPos) => {
        return inPos.price;
      });
      this.gesNet = this.formatCurrency(
        nets.reduce((total, current) => {
          return total + current;
        })
      );
    },
    roundCurrency(number) {
      return parseFloat(Math.round(number * 100) / 100);
    },
    formatCurrency(number) {
      let roundedNumber = this.roundCurrency(number);
      return roundedNumber
        .toFixed(2)
        .toString()
        .replace(".", ",");
    },
    submitShare(id) {
      let vm = this;
      this.order.incomplete = false;
      this.order.error = false;
      //this.order.success = false;
      if (this.order.prename == "" || this.order.surname == "") {
        this.order.incomplete = true;
      } else {
        vm.order.user = vm.did;
        vm.order.menuPlan = id;
        let postUrl = this.backendServer + "order/";
        axios
          .post(postUrl, vm.order)
          .then(function() {
            vm.showSection = false;
            vm.resetData();
            vm.order.success = true;
          })
          .catch(function(e) {
            vm.order.error = true;
          });
      }
    },
    resetData() {
      //reset data
      this.order = {
        prename: "",
        surname: "",
        phone: "",
        email: "",
        incomplete: false,
        error: false,
        success: false,
        user: null,
        orderItems: [],
      };
    },
  },
};
</script>
<style>
.md-table-cell-small {
  padding: 1px 4px !important;
  font-size: 13px !important;
}

.md-card-content {
  padding-right: 10px !important;
  padding-left: 10px !important;
}

.md-table-head {
  padding: 0 !important;
}
</style>
